import { For, Show } from "solid-js";
import { signInUrl } from "~/modules/shared/utils/auth";

type Props = {
	prompts: string[];
	isSignedIn: boolean;
};

/**
 * The gated branch of a shared, paid-access snapshot: the prompts that were
 * asked, each with a blurred placeholder where its answer would be —
 * AskPageSharedThreadPresenter withholds the actual answers and clone ids
 * server-side, so there is nothing to reveal here even by mistake — plus the
 * same sign-in-vs-subscribe messaging AskPageAccessNotice already uses on
 * the live ask-page header.
 */
export const SharedSnapshotGatedPreview = (props: Props) => (
	<div class="ask-page__thread">
		<For each={props.prompts}>
			{(prompt) => (
				<div class="ask-page__thread-item">
					<p class="ask-page__thread-question">{prompt}</p>
					<div class="ask-page__thread-answer-blur" aria-hidden="true">
						<span />
						<span />
						<span />
					</div>
				</div>
			)}
		</For>
		<p class="ask-page__access-notice">
			<Show
				when={!props.isSignedIn}
				fallback="An active pass or subscription is required to see this answer."
			>
				<a href={signInUrl()}>Sign in</a> to see this creator's access options.
			</Show>
		</p>
	</div>
);
